import type { FC } from "react";
import type { AdvisorConfirmCopy } from "web_myplann/Advisor/Types/AdvisorConfirmCopy";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ConfirmDrawer } from "web_myplann/Shared/Components/ConfirmDrawer";

const R = Resources.Advisor;

type Props = {
	open: boolean;
	copy: AdvisorConfirmCopy;
	advisorName: string;
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export const AdvisorConfirmDrawer: FC<Props> = ({
	open,
	copy,
	advisorName,
	loading,
	onClose,
	onConfirm,
}) => {
	const { t } = useResource();

	return (
		<ConfirmDrawer
			open={open}
			title={t(copy.title)}
			description={t(copy.description, { name: advisorName })}
			confirmLabel={t(copy.confirmLabel)}
			cancelLabel={t(R.keep)}
			isPending={loading}
			cancelAsLink
			onClose={onClose}
			onConfirm={onConfirm}
		/>
	);
};
